import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Calendar, MapPin, Users, Phone, Mail } from "lucide-react";
import api from "@/lib/api";

const STATUS = ["new", "confirmed", "declined", "done"];
const badge = { new: "bg-sky", confirmed: "bg-green-200", declined: "bg-slate-200", done: "bg-sun" };

export default function BookingsTab() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/event-bookings").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => {
    try { await api.put(`/admin/event-bookings/${id}`, { status }); load(); } catch { toast.error("Failed"); }
  };
  return (
    <div data-testid="admin-bookings">
      <h1 className="font-display font-bold text-3xl mb-1">Event Bookings</h1>
      <p className="text-ink/60 mb-6">{items.length} booking request(s).</p>
      <div className="space-y-3">
        {items.length === 0 && <div className="brut-card p-6 text-ink/60">No event requests yet.</div>}
        {items.map((b) => (
          <div key={b.id} className="brut-card p-4" data-testid={`booking-${b.id.slice(0,8)}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-display font-bold text-lg">{b.name}</div>
                <div className="text-sm text-ink/70 flex flex-wrap gap-x-4 gap-y-1 mt-1">
                  <span className="flex items-center gap-1"><Mail className="w-3.5 h-3.5" />{b.email}</span>
                  {b.phone && <span className="flex items-center gap-1"><Phone className="w-3.5 h-3.5" />{b.phone}</span>}
                  {b.event_date && <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{b.event_date}</span>}
                  {b.location && <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{b.location}</span>}
                  {b.headcount && <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" />{b.headcount}</span>}
                </div>
                {b.message && <p className="text-sm mt-2 text-ink/80">{b.message}</p>}
              </div>
              <select value={b.status} onChange={(e) => setStatus(b.id, e.target.value)}
                className={`brut-input !py-2 !w-auto text-sm font-semibold ${badge[b.status] || ""}`} data-testid={`booking-status-${b.id.slice(0,8)}`}>
                {STATUS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="text-xs text-ink/40 mt-2">{new Date(b.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
